import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "support"
const SupportIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.388 13.85C15.156 14.567 14.703 15.19 14.094 15.633S12.752 16.312 12 16.312 10.515 16.075 9.906 15.633 8.844 14.566 8.612 13.851L9.682 13.503C9.84 13.993 10.15 14.419 10.567 14.722 10.984 15.024 11.485 15.188 12 15.188S13.016 15.024 13.433 14.722C13.849 14.419 14.159 13.992 14.318 13.502zM9.563 10.125C10.08 10.125 10.5 10.545 10.5 11.063 10.5 11.58 10.08 12 9.563 12S8.625 11.58 8.625 11.063 9.045 10.125 9.563 10.125M14.438 10.125C14.955 10.125 15.375 10.545 15.375 11.063 15.375 11.58 14.955 12 14.438 12S13.5 11.58 13.5 11.063 13.92 10.125 14.438 10.125" />
          <path
            fillRule="evenodd"
            d="M12 1.5C13.191 1.5 14.37 1.756 15.466 2.251 16.562 2.747 17.554 3.471 18.386 4.38 19.22 5.287 19.877 6.362 20.324 7.54Q20.457 7.89 20.563 8.25H21C21.828 8.25 22.5 8.922 22.5 9.75V14.25C22.5 15.078 21.828 15.75 21 15.75H20.563Q20.457 16.11 20.323 16.46C19.876 17.638 19.22 18.713 18.387 19.62 17.554 20.53 16.562 21.254 15.466 21.749 14.369 22.245 13.19 22.5 12 22.5 11.586 22.5 11.25 22.164 11.25 21.75S11.586 21 12 21C12.975 21 13.943 20.79 14.848 20.381 15.754 19.971 16.581 19.371 17.281 18.607 17.98 17.844 18.539 16.934 18.92 15.928L18.985 15.75H18.495C17.197 17.991 14.774 19.5 12 19.5S6.803 17.991 5.506 15.75H3C2.172 15.75 1.5 15.078 1.5 14.25V9.75C1.5 8.922 2.172 8.25 3 8.25H3.437Q3.544 7.89 3.677 7.54C4.124 6.362 4.78 5.287 5.613 4.38 6.446 3.47 7.438 2.746 8.534 2.25 9.631 1.756 10.81 1.5 12 1.5M12 6C8.686 6 6 8.686 6 12S8.686 18 12 18 18 15.314 18 12 15.314 6 12 6M3 14.25H4.5V9.75H3zM19.5 14.25H21V9.75H19.5zM12 3C11.025 3 10.057 3.21 9.152 3.619 8.246 4.029 7.419 4.629 6.719 5.393 6.02 6.156 5.461 7.066 5.08 8.072L5.015 8.25H5.505C6.804 6.009 9.226 4.5 12 4.5S17.198 6.009 18.494 8.25H18.985Q18.955 8.16 18.921 8.072C18.539 7.066 17.98 6.156 17.28 5.392 16.58 4.63 15.754 4.029 14.848 3.62 13.943 3.209 12.975 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SupportIcon
